import {Component} from '@angular/core';
import {LanguageService} from '../../services/language.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  copyright = 'QuickHub All rights reserved | 2022 &copy;';

  constructor(public languageService: LanguageService) { }
}
